/* ============================================================
   Our Nation Under Prayer — homepage interactions
   (mobile menu · scroll reveals · counters · reviews carousel ·
    cursor glow) — vanilla JS, reduced-motion aware
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    /* ---- Mobile menu overlay ---- */
    var menu = document.getElementById('mobileMenu');
    if (menu) {
      var openBtn = document.querySelector('[data-menu-open]');
      var closeEls = menu.querySelectorAll('[data-menu-close], .mobile-menu__nav a');

      var open = function () {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };
      var close = function () {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };

      if (openBtn) openBtn.addEventListener('click', open);
      closeEls.forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
      });
    }

    /* ---- Header: transparent over hero → solid after first section ---- */
    var siteHeader = document.querySelector('.site-header--overlay');
    if (siteHeader) {
      var heroEl = document.querySelector('.hero');
      var solidify = function () {
        var h = heroEl ? heroEl.offsetHeight : window.innerHeight;
        siteHeader.classList.toggle('is-solid', window.scrollY > (h - siteHeader.offsetHeight - 1));
      };
      solidify();
      window.addEventListener('scroll', solidify, { passive: true });
      window.addEventListener('resize', solidify);
    }

    /* ---- Scroll reveals ---- */
    var reveals = document.querySelectorAll('.reveal');
    if (hasIO && !reduce) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            ro.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---- Count-up numbers (0 → value) ---- */
    function runCount(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = target + suffix; return; }
      var dur = 1600, start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target) + suffix;
        if (p < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target + suffix;
          el.classList.add('count-done');
        }
      }
      requestAnimationFrame(step);
    }

    var counters = document.querySelectorAll('[data-count]');
    if (hasIO) {
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { co.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = el.getAttribute('data-count') + (el.getAttribute('data-suffix') || '');
      });
    }

    /* ---- Reviews carousel: drag + wheel to scroll horizontally ---- */
    document.querySelectorAll('.reviews__track').forEach(function (track) {
      function scrollable() { return track.scrollWidth - track.clientWidth > 4; }
      function refreshCursor() { track.classList.toggle('is-grab', scrollable()); }
      refreshCursor();
      window.addEventListener('resize', refreshCursor);

      track.addEventListener('wheel', function (e) {
        if (!scrollable()) return;
        var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        var atStart = track.scrollLeft <= 0;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if ((d < 0 && atStart) || (d > 0 && atEnd)) return;
        e.preventDefault();
        track.scrollLeft += d;
      }, { passive: false });

      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || !scrollable()) return;
        down = true; moved = 0;
        startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        moved += Math.abs(dx);
        track.scrollLeft = startLeft - dx;
      });
      function endDrag(e) {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });

    /* ---- Cursor-following glow on category cards ---- */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine) {
      document.querySelectorAll('.cat-card').forEach(function (card) {
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          card.style.setProperty('--gx', (e.clientX - r.left) + 'px');
          card.style.setProperty('--gy', (e.clientY - r.top) + 'px');
        });
        card.addEventListener('pointerleave', function () {
          card.style.removeProperty('--gx');
          card.style.removeProperty('--gy');
        });
      });
    }
  });
})();
